export const APP_NAME: string = "Priority Pet";